<template>
  <v-container style="max-width: 600px;">
    <v-timeline dense clipped>
      <div v-if="newAPK">
        <v-timeline-item hide-dot class="pb-1">
          <span class="overline">{{convertDate(newAPK.fecha)}}</span>
          <span class="overline grey--text ml-2">{{convertTime(newAPK.fecha)}}</span>
        </v-timeline-item>

        <v-timeline-item class="mb-4" color="yellow darken-3">
          <v-row justify="space-between">
            <v-col cols="12">
              <VChip color="yellow darken-2" small class="mr-2">{{newAPK.ver}}</VChip>
              <v-btn color="yellow darken-2" class="white--text ml-0 overline" small label :href="`/apk/SafeTaxi_${newAPK.ver}.apk`">
                <v-icon class="pr-4" x-small="">fa-download</v-icon>descargar
              </v-btn>
              <ul class="mt-5 pl-0 caption font-weight-light">
                <li v-for="(cambio, i) in newAPK.descripcion.split('\n')" :key="i">{{cambio}}</li>
              </ul>
            </v-col>
          </v-row>
        </v-timeline-item>
      </div>

      <custom-time-line-item 
        v-for="v in versiones" 
        :key="v.ver" 
        :ver="v.ver" 
        :fecha="convertDate(v.fecha)" 
        :time="convertTime(v.fecha)" 
        :descripcion="v.descripcion"/>
      
    </v-timeline>
  </v-container>
</template>


<script>
import CustomTimeLineItem from '@/components/TimeLineItem'
export default {
  data: ()=> ({
    newAPK: null,
    versiones: []
  }),
  methods: {
    async getVersiones(){
      const req = await fetch('http://api.safetaxi.mx/utils/getVersiones')
      const res = await req.json()
      this.newAPK = res[0]
      for(let i = 1; i < res.length; i++)
        this.versiones.push(res[i])
    },
    convertDate(date){
      let t = date.split(/[- :]/)
      let _date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]))
      // console.log(_date.getMonth())
      return `${_date.getDate()} de ${this.getMes(_date.getMonth())} de ${_date.getFullYear()}`
    },
    convertTime(date){
      let t = date.split(/[- :]/)
      let _date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]))
      // console.log(_date)
      return `${_date.getUTCHours()}:${_date.getMinutes()}:${_date.getSeconds()}`
    },
    getMes(mes){
      switch(mes){
        case 0: return 'Enero'; break;
        case 1: return 'febrero'; break;
        case 2: return 'marzo'; break;
        case 3: return 'abril'; break;
        case 4: return 'mayo'; break;
        case 5: return 'junio'; break;
        case 6: return 'julio'; break;
        case 7: return 'agosto'; break;
        case 8: return 'septiembre'; break;
        case 9: return 'octubre'; break;
        case 10: return 'noviembre'; break;
        case 11: return 'diciembre'; break;
      }
    }
  },
  async created(){
    await this.getVersiones()
  },
  components: {
    CustomTimeLineItem
  }
};
</script>